import { render, staticRenderFns } from "./InformationRiskLevel.vue?vue&type=template&id=e4bfb4e4&scoped=true"
import script from "./InformationRiskLevel.vue?vue&type=script&lang=js"
export * from "./InformationRiskLevel.vue?vue&type=script&lang=js"
import style0 from "./InformationRiskLevel.vue?vue&type=style&index=0&id=e4bfb4e4&prod&scoped=true&lang=css"
import style1 from "./InformationRiskLevel.vue?vue&type=style&index=1&id=e4bfb4e4&prod&lang=css"
import style2 from "./InformationRiskLevel.vue?vue&type=style&index=2&id=e4bfb4e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bfb4e4",
  null
  
)

export default component.exports